import { createContext, useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL, DEV_TOKEN } from "../config/apiConstants";
import { getCurrentUser } from "../request/user";
import { getToken } from "../helpers/getToken";

export const AuthContext = createContext();
export const AuthContextProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const token = getToken();

  const isDev = process.env.NODE_ENV === "development";

  if (isDev) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + DEV_TOKEN;
  }

  axios.defaults.baseURL = API_BASE_URL;
  if (token) {
    axios.defaults.headers.common["X-XSRF-TOKEN"] = token;
  }
  axios.defaults.headers.common["Content-Type"] = "application/json";
  axios.defaults.headers.common["Accept"] = "application/json";

  useEffect(() => {
    if (token && currentUser == null) {
      const getUser = async () => {
        let response = await getCurrentUser().catch((err) => {
          console.error(err);
        });
        setCurrentUser(response?.data?.data ?? false);
        setIsLoading(false);
      };

      getUser().catch((err) => {
        console.error(err);
      });
    }
  }, [currentUser]);

  return (
    <AuthContext.Provider value={{ currentUser, isLoading, setIsLoading }}>
      {children}
    </AuthContext.Provider>
  );
};
